import gql from 'graphql-tag';

export const HOME_PAGE_BLOG_FRAGMENT = gql`
  fragment homePageBlog on HomePageBlogType {
    blogTitle
    blogButtonText
    blogButtonUrl
    blogDescription
  }
`;
